import {Route} from "react-router-dom";
import UrlsConfig from "@/config/UrlsConfig";
import {lazy} from "react";

const ViewApplication = lazy(() => import("@/pages/ControlPanel/Nested/ApplicationsForChangePersonalData/ViewApplication"));

const urlsConfig = new UrlsConfig();

export function applicationsForChangePersonalDataRoutes() {
    return (
      <>
          <Route
            path={`${urlsConfig.inControlPanelViewApplicationForChangePersonalData.to}/:applicationId`}
            element={<ViewApplication/>}
          />
      </>
    );
}
